// This file was generated using `pay js:run gql-v1 --type=fragment --name=BlockchainAddressExternalAccount --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument} from '@sail/data';
import type {
  Exact,
  OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddressObjectFieldType,
  OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddressNetworkEnum,
} from '@stripe-internal/data-v1/schema/types';

import type {V1PermissionToken} from '@stripe-internal/data-v1/types';

const doc = gql`
  fragment BlockchainAddressExternalAccountFragment on OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddress {
    id
    object
    default_for_currency
    currency
    address
    created
    fingerprint
    network
  }
`;

export const blockchainAddressExternalAccountFragment: BlockchainAddressExternalAccountFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type BlockchainAddressExternalAccountFragmentData = {
  readonly __typename: 'OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddress';
  readonly id: string;
  readonly object: OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddressObjectFieldType;
  readonly default_for_currency: boolean | null;
  readonly currency: string;
  readonly address: string;
  readonly created: number;
  readonly fingerprint: string;
  readonly network: OpenapiCryptocurrencyBlockchainAddressResourceExternalAccountBlockchainAddressNetworkEnum;
};

export type BlockchainAddressExternalAccountFragmentVariables = Exact<{
  [key: string]: never;
}>;

const blockchainAddressExternalAccountFragmentPermissions = {} as const;

doc.permissions = blockchainAddressExternalAccountFragmentPermissions;

export type BlockchainAddressExternalAccountFragmentPermissions =
  V1PermissionToken<typeof blockchainAddressExternalAccountFragmentPermissions>;

export type BlockchainAddressExternalAccountFragmentDocument = GraphQlDocument<
  BlockchainAddressExternalAccountFragmentData,
  BlockchainAddressExternalAccountFragmentVariables,
  BlockchainAddressExternalAccountFragmentPermissions
>;
